import CryptoJS from 'crypto-js';

const SECRET_KEY = process.env.NEXT_PUBLIC_AES_SECRET_KEY as string;

function getKeyAndIV(secretKey: string) {
  // SHA-256 해시 후 16바이트(32 hex chars) 추출
  const hash = CryptoJS.SHA256(secretKey).toString(CryptoJS.enc.Hex);
  const keyHex = hash.substring(0, 16); // 16 bytes = 32 hex chars
  const key = CryptoJS.enc.Utf8.parse(keyHex);
  const iv = key; // PHP와 동일하게 IV = key
  return { key, iv };
}

// AES-128 암호화
export function encryptAES128(str: string) {
  if (!str) return null;
  const { key, iv } = getKeyAndIV(SECRET_KEY);
  const encrypted = CryptoJS.AES.encrypt(str, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  // 2중 base64 인코딩
  const base64 = encrypted.ciphertext.toString(CryptoJS.enc.Base64);
  const reBase64 = CryptoJS.enc.Base64.stringify(
    CryptoJS.enc.Utf8.parse(base64),
  );
  return reBase64;
}

// AES-128 복호화. 암호문이 아니면(깨진 값) null — 던지지 않는다.
// 앱이 위치가 없을 때 `encryptLocation=(null)` 을 그대로 보내는데(iOS 7.3.5 이하), 예전엔 여기서
// "Malformed UTF-8 data" 가 터져 내정보·학원찾기 페이지 전체가 "Application error" 로 죽었다.
export function decryptAES128(str: string) {
  if (!str) return null;

  try {
    const { key, iv } = getKeyAndIV(SECRET_KEY);
    const base64 = CryptoJS.enc.Utf8.stringify(CryptoJS.enc.Base64.parse(str));
    const encryptedHex = CryptoJS.enc.Base64.parse(base64);
    const cipherParams = CryptoJS.lib.CipherParams.create({
      ciphertext: encryptedHex,
    });
    const decrypted = CryptoJS.AES.decrypt(cipherParams, key, {
      iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    return decrypted.toString(CryptoJS.enc.Utf8) || null;
  } catch {
    return null;
  }
}

/** 결제 주문 숫자 id → `/member-account/me/order/{…}` 등 API·URL 경로용 암호문 */
export function encryptPayOrderIdForApi(payOrderId: number): string {
  return encryptAES128(String(payOrderId)) ?? String(payOrderId);
}
